import { Hint } from "@/HOC";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import NoOptionText from "../NoOptionText/NoOptionText";
import { FC, useLayoutEffect, useRef, useState } from "react";
import ProgressCircle from "@/components/MUI/ProgressCircle/ProgressCircle";
import { colorPrimary } from "@/constants/colors";
import { useTranslate } from "@/hooks";
import { IAutocompleteWithIconSmall } from "./AutocompleteWithIconSmall.props";

const AutocompleteWithIconSmall: FC<IAutocompleteWithIconSmall> = ({
	value,
	isDisabled,
	fontSize = 13,
	height = "19.33px",
	isLoading,
	options,
	handleChange,
	ml = 8,
	hint = "",
	icon,
	...props
}) => {
	const textRef = useRef<HTMLSpanElement>(null);
	const inputRef = useRef<HTMLInputElement>(null); // ссылка на автокоплит голоса

	const [inputWidth, setInputWidth] = useState(150);
	const translate = useTranslate();

	useLayoutEffect(() => {
		if (textRef.current) {
			const additionalWidth = -20;
			const width = !value || value?.length === 0 ? 0 : textRef.current.offsetWidth + additionalWidth;

			setInputWidth(width); // текст + иконка + паддинги
		}
	}, [value]);

	return (
		<div style={{ position: "relative", display: "inline-flex" }}>
			{/* Скрытый измеритель текста */}
			<span
				ref={textRef}
				style={{
					position: "absolute",
					visibility: "hidden",
					whiteSpace: "pre",
					fontSize,
					fontFamily: "Roboto",
					fontWeight: 400,
					padding: "0 6px",
				}}
			>
				{icon ? <FontAwesomeIcon icon={icon} /> : null}
				{value || " "}
			</span>
			<Hint hint={translate("hint_actionVoice")} position="top">
				<Autocomplete
					{...props}
					options={options}
					value={value}
					openOnFocus
					onChange={(_, value) => handleChange(value)}
					noOptionsText={<NoOptionText style={{ fontSize: "10px" }} />}
					disabled={isDisabled}
					slotProps={{
						paper: {
							sx: {
								width: "fit-content",
								minWidth: "fit-content",
							},
						},
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							InputLabelProps={{
								style: {
									fontSize: fontSize,
								},
							}}
							inputRef={inputRef}
							sx={{
								ml: `${ml}px`,
								"& .MuiInputBase-input": {
									width: "auto",
									padding: "0 !important",
									height: height,
									boxSizing: "border-box",
								},
								"& .MuiOutlinedInput-root": {
									padding: "0 6px !important",
									height: height,
									backgroundColor: "#dfdfdf",
								},
							}}
							InputProps={{
								...params.InputProps,
								startAdornment: icon ? (
									<FontAwesomeIcon
										onClick={(e) => {
											e.stopPropagation();
											inputRef.current?.focus();
										}}
										icon={icon}
										style={{ marginRight: !value || value?.length === 0 ? 0 : 6, cursor: isDisabled ? "default" : "pointer", fontSize }}
									/>
								) : (
									<></>
								),
								endAdornment: (
									<div>
										{isLoading && <ProgressCircle isBtnDisabled />}
										{params.InputProps.endAdornment}
									</div>
								),
							}}
						/>
					)}
					sx={{
						width: "fit-content",
						display: "inline-flex",

						"& .MuiOutlinedInput-root": {
							height: height,
							padding: "0 6px",
							backgroundColor: "#dfdfdf",
						},
						"& .MuiAutocomplete-input": {
							width: `${inputWidth}px !important`,
							minWidth: `${inputWidth}px !important`,
							boxSizing: "content-box",
						},

						"& .MuiInputBase-input": {
							fontSize: fontSize,
							padding: 0,
							height: height,
						},

						"& .MuiAutocomplete-popupIndicator": { display: "none" },
						"& .MuiAutocomplete-clearIndicator": { display: "none" },
					}}
					getOptionLabel={(option) => option}
					renderOption={(props, option) => {
						return (
							<span {...props} style={{ fontSize: fontSize, color: colorPrimary }}>
								{option === "" ? (
									icon ? (
										<FontAwesomeIcon
											onClick={(e) => {
												e.stopPropagation();

												inputRef.current?.focus();
											}}
											icon={icon}
										/>
									) : (
										<></>
									)
								) : (
									<>{option}</>
								)}
							</span>
						);
					}}
				/>
			</Hint>
		</div>
	);
};

export default AutocompleteWithIconSmall;
